// react
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

// components
import {
  CareSearchShortlistsPage,
  ShortlistCardData,
} from '@karehero/llama/pwa/pages/CareSearchShortlistsPage/CareSearchShortlistsPage';

// store
import { useListPublishedShortlistsQuery } from 'store/api/shortlist';

// hooks
import { useCareCircle } from 'hooks';
import { AccountRole, useTenant } from 'context';

// router
import { DYNAMIC_ROUTES } from 'router/routes';
import CareSearch from './CareSearch';
import AdminCareSearch from './AdminCareSearch';

export const CareSearchShortlists = () => {
  const navigate = useNavigate();
  const { tenant } = useTenant();
  const { careCircleId, careRecipientFirstName } = useCareCircle();

  const { data: shortlists, isLoading } = useListPublishedShortlistsQuery(
    careCircleId || '',
    {
      skip: !careCircleId,
    },
  );

  const shortlistCards: ShortlistCardData[] = useMemo(
    () =>
      (shortlists || [])
        .filter((s) => s.isPublished && !s.isArchived)
        .map((shortlist) => ({
          id: shortlist.id,
          name: shortlist.name,
          providerCount: shortlist.numProviders,
          securedCount: 0,
          updatedAt: shortlist.updatedAt || shortlist.createdAt || '',
          onClick: () => {
            navigate(DYNAMIC_ROUTES.SHORTLIST_DETAIL(shortlist.id));
          },
        })),
    [shortlists],
  );

  if (!isLoading && shortlistCards.length === 0) {
    return tenant.accountRole === AccountRole.ADMIN ? (
      <AdminCareSearch />
    ) : (
      <CareSearch />
    );
  }

  return (
    <CareSearchShortlistsPage
      careRecipientFirstName={careRecipientFirstName || 'your loved one'}
      shortlists={shortlistCards}
      isLoading={isLoading}
    />
  );
};

export default CareSearchShortlists;
